'use client';

import { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { useAppDispatch, useAppStore } from 'lib/hooks';
import { Destination } from 'types/content';
import routes from 'lib/routing';
import * as Sentry from '@sentry/nextjs';

type PathfinderProps = {
  destinations: Destination[];
};

const Pathfinder = ({ destinations }: PathfinderProps) => {
  const pathname = usePathname();
  const router = useRouter();
  const dispatch = useAppDispatch();
  const store = useAppStore();

  useEffect(() => {
    const entry = routes[pathname as keyof typeof routes];

    if (!entry) {
      Sentry.logger.error('No route entry found', { pathname });
      // eslint-disable-next-line no-console
      console.debug('[Pathfinder] No route entry found', { pathname });
      return;
    }

    const state = store.getState();
    const slug = entry.execute(state, dispatch);

    if (slug === null) {
      Sentry.logger.error('Destination not found', { pathname });
      // eslint-disable-next-line no-console
      console.debug('[Pathfinder] Destination not found', { pathname });
      return;
    }

    router.push(`/${slug}`);
  }, [pathname, destinations]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default Pathfinder;
